import React, { useEffect, useState } from 'react'
import SupplyBillTable from './SupplyBillTable'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getSupplyBillsAPI } from '../../../api/supply/supplyBillAPI'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyBillsCount, setSupplyBillsLimit, setSupplyBillsList, setSupplyBillsOffset } from '../../../store/supplyBillSlice'
import ErrorMessage from '../../UI/messages/ErrorMessage'

const SupplyBillList = () => {

    const supplyBills = useSelector(state => state.supplyBill.supplyBills.list)
    const count = useSelector(state => state.supplyBill.supplyBills.count)
    const limit = useSelector(state => state.supplyBill.supplyBills.limit)
    const offset = useSelector(state => state.supplyBill.supplyBills.offset)
    const query = useSelector(state => state.supplyBill.supplyBills.query)
    const status = useSelector(state => state.supplyBill.supplyBills.filters.status)
    const paymentStatus = useSelector(state => state.supplyBill.supplyBills.filters.paymentStatus)
    const agreeNachSupply = useSelector(state => state.supplyBill.supplyBills.filters.agreeNachSupply)
    const agreeEconomist = useSelector(state => state.supplyBill.supplyBills.filters.agreeEconomist)
    const agreeDeputyDirectorSupply = useSelector(state => state.supplyBill.supplyBills.filters.agreeDeputyDirectorSupply)
    const agreeHeader = useSelector(state => state.supplyBill.supplyBills.filters.agreeHeader)

    // Сортування
    const sortField = useSelector(state => state.supplyBill.supplyBills.sort.field)
    const sortType = useSelector(state => state.supplyBill.supplyBills.sort.type)

    const dispatch = useDispatch()

    // const [count, setCount] = useState(0)
    // const [limit, setLimit] = useState(10)
    // const [offset, setOffset] = useState(0)
    // const [query, setQuery] = useState('')

    // const [supplyBills, setSupplyBills] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        
        // Функція для затримки
        const handler = setTimeout(() => {
            getSupplyBills()
        }, 300) // 300 мс затримки

        return () => clearTimeout(handler)

    }, [
        limit, offset, query, status, paymentStatus, agreeNachSupply, agreeEconomist, agreeDeputyDirectorSupply, agreeHeader,
        sortField, sortType
    ])

    const getSupplyBills = () => {
        setLoading(true)
        setError('')
        getSupplyBillsAPI({ 
            offset, limit, query, status, paymentStatus, agreeNachSupply, agreeEconomist, agreeDeputyDirectorSupply, agreeHeader,
            sortField, sortType
        }).then(data => {
            // setCount(data.count)
            // setSupplyBills(data.supplyBills)
            dispatch(setSupplyBillsCount(data.count))
            dispatch(setSupplyBillsList(data.supplyBills))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <ErrorMessage error={error} />

        <SupplyBillTable
            supplyBills={supplyBills}
            count={count}
            limit={limit}
            setLimit={e => dispatch(setSupplyBillsLimit(e))}
            offset={offset}
            setOffset={e => dispatch(setSupplyBillsOffset(e))}
            loading={loading}
        />
    </div>
  )
}

export default SupplyBillList